import React from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';

interface Prop {
    provisions: Array<any>;
}
interface State {}

@injectIntl()
export default class Provision extends Base<Prop, State> {
    constructor(prop: Prop) {
        super(prop);
    }

    componentDidMount() {}

    render() {
        const { provisions } = this.props;
        if (!provisions?.length) {
            return null;
        }
        return (
            <>
                <div className="sendbox">
                    <div className="boxs unote mar_top white_bg">
                        <div className="User_notes">
                            <div className="uttl  title">
                                <h1>
                                    <FormattedMessage id="customer-instructions.title" />
                                </h1>
                            </div>
                            {provisions?.map(item => {
                                return (
                                    <React.Fragment key={item.title}>
                                        <div className="note_title">{item.title}</div>
                                        <div className="note_text" dangerouslySetInnerHTML={{ __html: item.content }}></div>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
